export const LoginRouting = {
  path: "/login",
  name: "login",
  meta: { title: "工程企业管理软件" },
  component: () => import(/* webpackChunkName: "login" */ "@/views/login/index.vue"),
  children: [],
};
